export default "__VITE_ASSET__BwM3Rtzk__"